export default function HeartIcon(
  props: Pick<
    React.SVGProps<SVGSVGElement>,
    "fill" | "fillOpacity" | "className"
  >,
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      className={props.className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.62658 5.97079C6.45075 5.08891 4.80539 5.20584 3.76609 6.24514C2.61269 7.39854 2.61269 9.26857 3.76609 10.422L8.78073 15.4366C9.72979 16.3857 11.2685 16.3857 12.2176 15.4366L17.2322 10.422C18.3856 9.26857 18.3856 7.39854 17.2322 6.24514C16.1929 5.20584 14.5476 5.08891 13.3717 5.97079L11.2064 7.5948C10.7873 7.90913 10.211 7.90913 9.79194 7.5948L7.62658 5.97079ZM2.58758 5.06663C4.21336 3.44085 6.78721 3.25793 8.62658 4.63745L10.4992 6.04189L12.3717 4.63745C14.2111 3.25793 16.785 3.44085 18.4108 5.06663C20.215 6.8709 20.215 9.79621 18.4108 11.6005L13.3961 16.6151C11.7962 18.2151 9.20216 18.2151 7.60222 16.6151L2.58758 11.6005C0.783307 9.79621 0.783306 6.8709 2.58758 5.06663Z"
        fill={props.fill || "#0F1324"}
        fillOpacity={props.fillOpacity || "0.6"}
      />
    </svg>
  );
}
